import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { NotificationProvider } from './shared/contexts/NotificationContext';
import NotificationContainer from './shared/components/NotificationContainer';
import AdminApp from './admin/AdminApp';
import ClientApp from './client/ClientApp';

function App() {
  return (
    <NotificationProvider>
      <BrowserRouter>
        <Routes>
          {/* Admin Routes */}
          <Route path="/admin/*" element={<AdminApp />} />
          
          {/* Cliente routes */}
          <Route path="/*" element={<ClientApp />} />
        </Routes>
      </BrowserRouter>
      <NotificationContainer />
    </NotificationProvider>
  );
}

export default App;

